export enum OBJECT_VIEW_MODES {
	LIST,
	SMALL_THUMBNAILS,
	THUMBNAILS,
}
